import delay from '@redux-saga/delay-p';
import { all, call } from 'redux-saga/effects';

/**
 * Sometimes we need to time/delay the execution of various saga effects typically to coordinate various UI animations.
 * This function ensures that the provided effect will execute for AT LEAST the "duration" but may take longer if the provided effect takes longer (e.g. a long API call).
 * This simplifies that interface and provides a default duration to keep these delays consistent across the app, but allows overriding when needed.
 * @param {object} effect - a redux-saga effect
 * @param {number} duration - the minimum duration that this effect should execute for
 */
export function* minDurationEffect(effect, duration = 500) {
  const effectResult = yield effect; //execute the effect
  yield call(delay, duration); //first we wait for 'duration' time
  return effectResult;
}
